import { color } from "@sencrop/ui-components";
import styled from "styled-components";
import Loader from "../../../components/Loader";

type Position = ("top" | "bottom" | "left" | "right")[];

type MapLoadingOverlayProps = {
  size?: number;
  blocking?: boolean;
  position?: Position;
  children?: React.ReactNode;
};

const getFlexAlignment = (position: Position) => {
  let justifyContent = "center";
  let alignItems = "center";
  if (position.includes("top")) alignItems = "flex-start";
  if (position.includes("bottom")) alignItems = "flex-end";
  if (position.includes("left")) justifyContent = "flex-start";
  if (position.includes("right")) justifyContent = "flex-end";
  return { justifyContent, alignItems };
};

const MapLoadingOverlay = (props: MapLoadingOverlayProps) => {
  const { size = 50, blocking = true, position = [], children } = props;

  const { justifyContent, alignItems } = getFlexAlignment(position);

  return (
    <LoadingOverlay
      blocking={blocking}
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <LoaderContainer size={size}>
        <Loader size={size} />
        <ChildrenContainer size={size}>{children}</ChildrenContainer>
      </LoaderContainer>
    </LoadingOverlay>
  );
};

export default MapLoadingOverlay;

const LoadingOverlay = styled.div<{
  blocking: boolean;
  justifyContent: string;
  alignItems: string;
}>`
  z-index: 100000;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  pointer-events: ${({ blocking }) => (blocking ? "all" : "none")};
`;

const LoaderContainer = styled.div<{ size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size * 2}px;
  height: ${({ size }) => size * 2}px;
  background-color: ${color("background-primary:10")};
  border-radius: 6px;
  flex-direction: column;
  margin: 16px;
`;

const ChildrenContainer = styled.div<{ size: number }>`
  font-size: ${({ size }) => size * 0.5}px;
  text-align: center;
  max-width: 100%;
  word-break: break-word;
  color: ${color("text-primary")};
`;
